import type { FC } from 'react'
import styled from 'styled-components'

import Card from '@/components/Card'
import SmallPill from '@/components/SmallPill'

import type { FilterT } from './OutcomeReviewFilter'
import Filter, { DEFAULT_FILTER } from './OutcomeReviewFilter'

export interface SearchValues {
  filter: FilterT
}

export const DEFAULT_SEARCH: SearchValues = {
  filter: DEFAULT_FILTER,
}

interface Props {
  searchValues: SearchValues
  onChangeSearchValues: (searchValues: SearchValues) => void
  onSubmitSearchValues: (searchValues: SearchValues) => void
}

const Container = styled(Card)`
  padding: 15px;
  display: grid;
  grid-template-rows: 1fr min-content min-content;
  grid-row-gap: 20px;
  min-width: 290px;
  min-height: 0;
`

const SubmitContainer = styled.div`
  justify-self: end;
`

export const shouldDisableSearch = (filter: FilterT): boolean =>
  !filter.noOwner.onlyShowNoOwner &&
  !filter.identity.scottishWelsh.needsReview &&
  !filter.identity.scottishWelsh.reopened &&
  !filter.identity.other.needsReview &&
  !filter.identity.other.reopened &&
  !filter.credit.needsReview &&
  !filter.credit.reopened &&
  !filter.income.paye.needsReview &&
  !filter.income.paye.reopened &&
  !filter.income.other.needsReview &&
  !filter.income.other.reopened &&
  !filter.residential.needsReview &&
  !filter.residential.reopened

const OutcomeReviewSearchPanel: FC<Props> = ({
  searchValues,
  onChangeSearchValues,
  onSubmitSearchValues,
}) => (
  <Container>
    <Filter
      filter={searchValues.filter}
      onChangeFilter={newFilter =>
        onChangeSearchValues({
          ...searchValues,
          filter: newFilter,
        })
      }
    />
    <SubmitContainer>
      <SmallPill
        disabled={shouldDisableSearch(searchValues.filter)}
        onClick={() => onSubmitSearchValues(searchValues)}
      >
        Search
      </SmallPill>
    </SubmitContainer>
  </Container>
)

export default OutcomeReviewSearchPanel
